import {
  FilterOptionKeys,
  GroupByMode,
  SortingMode,
  TaskGroupBy,
} from '@griply/types';

export const todayGroupOptions = [
  GroupByMode.Deadline,
  GroupByMode.Goal,
  GroupByMode.LifeArea,
  GroupByMode.Priority,
  GroupByMode.Type,
  GroupByMode.DayPart,
] as const satisfies TaskGroupBy[];

export const todaySortOptions = [
  SortingMode.Custom,
  SortingMode.DueDate,
  SortingMode.Priority,
  SortingMode.CreatedAt,
] as const satisfies SortingMode[];

export const todayFilters = [
  FilterOptionKeys.Tag,
] as const satisfies FilterOptionKeys[];
